import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { LATEST_EVENT_BY_ENTITY_TYPES_QUERY } from '../graphql/queries'
import { COMMON_FETCH_LATEST_EVENT_BY_ENTITY_TYPES } from '../redux/action-types'
import { cleanupCommonFetchLatestEventByEntityTypes } from '../redux/actions'
import { apolloService } from '../services'

import useCleanupRedux from './use-cleanup-redux'

const useLatestEventByEntityTypesQuery = entityTypes => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupCommonFetchLatestEventByEntityTypes)

  const {
    isCommonFetchLatestEventByEntityTypesLoading: isLoading,
    fetchLatestEventByEntityTypesError: error,
    latestEventByEntityTypesData: data = {},
  } = useSelector(store => store.common.events)

  const refetch = useCallback(
    () =>
      apolloService.query(
        LATEST_EVENT_BY_ENTITY_TYPES_QUERY,
        { entityTypes },
        dispatch,
        COMMON_FETCH_LATEST_EVENT_BY_ENTITY_TYPES,
      ),
    [dispatch, entityTypes],
  )

  useEffect(() => {
    refetch()
  }, [refetch])

  return { isLoading, error, data, refetch }
}

export default useLatestEventByEntityTypesQuery
